import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import React from "react";
import { useStore } from "../store/Store";
import PublicationRow from "./PublicationRow";

interface State {}

const PublicationsTable = (props: any) => {
  const { state } = useStore();

  const handleChangePage = async (event: unknown, newPage: number) => {
    props.updatePaginationInfo({ ...props.paginationInfo, page: newPage + 1 });
  };

  const handleChangeRowsPerPage = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    props.updatePaginationInfo({
      ...props.paginationInfo,
      limit: +event.target.value,
      page: 1,
    });
  };
  // console.log(props.data);

  return (
    <>
      <TableContainer component={Paper} className="archive-table-container">
        <Table stickyHeader>
          <TableHead>
            {state.user.isAdmin ? (
              <TableRow>
                <TableCell />
                <TableCell>Year</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Authors</TableCell>
                <TableCell>DOI</TableCell>
                <TableCell>Keywords</TableCell>
                {state.user && <TableCell>Actions</TableCell>}
              </TableRow>
            ) : (
              <TableRow>
                <TableCell />
                <TableCell>Year</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Authors</TableCell>
                <TableCell>DOI</TableCell>
                <TableCell>Keywords</TableCell>
              </TableRow>
            )}
          </TableHead>
          <TableBody>
            {props.data &&
              props.data.map((publication: System.Publication) => {
                return (
                  <PublicationRow
                    key={publication.id}
                    publication={publication as System.Publication}
                    open={false}
                  />
                );
              })}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[
          5,
          10,
          25,
          props.paginationInfo.totalDocs > 25 && props.paginationInfo.totalDocs,
        ]}
        labelRowsPerPage={["Publications per page"]}
        component="div"
        style={{ overflow: "visible" }}
        count={
          props.paginationInfo.totalDocs ? props.paginationInfo.totalDocs : 0
        }
        rowsPerPage={props.paginationInfo.limit}
        page={props.paginationInfo.page - 1}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </>
  );
};

export default PublicationsTable;
